export enum WIMSAuthStatus {
  error = 'WIMS_AUTH_ERROR',
  success = 'WIMS_AUTH_SUCCESS',
}

export enum Variants {
  Default = 'default',
  Outlined = 'outlined',
}

export enum Colors {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum Size {
  Small = 'small',
  Medium = 'medium',
}

export enum PromoType {
  BuySave = 'BUY_SAVE',
  SubscribeSave = 'SUBSCRIBE_SAVE',
  PercentOff = 'PERCENT_OFF',
}
